export default "__VITE_ASSET__DmwhNQsK__";